import { render, staticRenderFns } from "./hotelJournal.vue?vue&type=template&id=bb0bc340&scoped=true&"
import script from "./hotelJournal.vue?vue&type=script&lang=js&"
export * from "./hotelJournal.vue?vue&type=script&lang=js&"
import style0 from "./hotelJournal.vue?vue&type=style&index=0&id=bb0bc340&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb0bc340",
  null
  
)

export default component.exports